import { render, staticRenderFns } from "./ElementFile.vue?vue&type=template&id=7cbe64dd&scoped=true&"
import script from "./ElementFile.vue?vue&type=script&lang=js&"
export * from "./ElementFile.vue?vue&type=script&lang=js&"
import style0 from "./ElementFile.vue?vue&type=style&index=0&id=7cbe64dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbe64dd",
  null
  
)

export default component.exports